
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!

import { GenFileFormat } from './GenFileFormat';

export class GenUserPreferences {

    downloadFileFormat: GenFileFormat;
    stateCodes: string[];
    userId: number;
    years: number[];

    constructor();
    constructor( jsonObj: any );
    constructor( genUserPreferences: GenUserPreferences);

    constructor( input?: GenUserPreferences ) {
        if ( input && typeof input !== 'number' ) {
            this.downloadFileFormat = (typeof input.downloadFileFormat === 'string') ? GenFileFormat.forName(<string> input.downloadFileFormat) : <any> input.downloadFileFormat; // GenFileFormat
            this.stateCodes = input.stateCodes; // list [string]
            this.userId = input.userId; // int [number]
            this.years = input.years; // list [number]
       }
    }

    static jsonResponseToList(arr: any[]): GenUserPreferences[] {
        if (arr && arr.map) {
          return arr.map(a => new GenUserPreferences(a));
        } else {
          return [];
        }
    }
}

